<template>
    <dumb-article title="견적서목록">
        <table v-if="estimates.length" class="table">
            <thead>
                <tr>
                    <th>견적일시</th>
                    <th>총견적금액</th>
                    <th>업체</th>
                    <th>견적확인</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="({ user: interior, ...estimate }, index) in estimates" :key="`interior-${index}`">
                    <td>{{ estimate.createDate.toDateTime() }}</td>
                    <td class="amount">{{ Math.round(calculateTotalAmount(estimate)).format() }} 원</td>
                    <td>
                        <a :href="`/partners/interior/${interior._id}`" target="_blank" rel="noopener noreferrer">{{ interior.meta.companyName }}</a>
                    </td>
                    <td><button @click="$emit('clickButton', estimate)">견적서</button></td>
                </tr>
            </tbody>
        </table>
        <div class="information">{{ estimates.length ? "견적 확인 후 새집처럼(1600-2325)에 연락주시면 계약 진행하실 수 있습니다." : "제출된 견적이 없습니다." }}</div>
    </dumb-article>
</template>
<script>
import DumbArticle from "./dumb-article.vue";
import { calculateTotalAmount } from "@/plugins/calculateEstimateTotalAmount";

export default {
    components: { DumbArticle },
    props: {
        estimates: { type: Array, default: null },
    },
    methods: {
        calculateTotalAmount,
    },
};
</script>
<style lang="scss" scoped>
.table {
    width: 100%;

    th,
    td {
        padding: 0.7rem 2.1rem;
        text-align: center;

        &.amount {
            font-size: 1.2rem;
        }
    }
    a {
        color: #07b162;
    }
}
.information {
    margin-top: 2.3rem;
    text-align: center;
    font-size: 1.2rem;
}

// .business {
//     > span {
//         margin-right: 1rem;
//         font-size: 1.2rem;
//     }
// }
// .section {
//     margin-bottom: 1rem;
// }
</style>
